import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "stores/Interfaces";
import { AutoComplete as AutoCompleteAntd, Form } from "antd";
import { FieldConfig } from "components/common/forms/Interfaces";
import { SearchInputValue } from "stores/LogisticStore";

interface Props {
  defaultValue: string;
  store?: IAppStore;
  name: string;
  defaultOptions: SearchInputValue[];
  config?: FieldConfig;
}

const Autocomplete: React.FC<Props> = ({
  store,
  defaultValue,
  name,
  defaultOptions,
  config,
  ...rest
}) => {
  const [options, setOptions] = useState<{ value: string }[]>([]);

  const getPanelValue = (searchText: string) => {
    return !searchText
      ? []
      : defaultOptions?.filter((option) => {
          return option?.value?.includes(searchText);
        });
  };

  return (
    <Form.Item
      name={name}
      label={config?.label}
      rules={config?.validationRules}
      labelCol={{ span: 24 }}
      style={{ marginBottom: 0 }}
      {...(config?.extra || {})}
      {...rest}
    >
      <AutoCompleteAntd
        defaultValue={defaultValue}
        options={options}
        style={{ height: 40, width: "100%" }}
        onSearch={(text: string) => setOptions(getPanelValue(text))}
      />
    </Form.Item>
  );
};

export default inject("store")(observer(Autocomplete));
